import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/AssessmentSlice";

import { constants } from "../../constants/common";
import { common } from "../../types";

import API from "../../services/rest/api";
import { PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const GetAssessmentDiseaseRequest = function* GetAssessmentDiseaseRequest({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(API.GetDiseasesData);
    if (Number(response.code) === 1) {
      yield put(actions.getAssessmentDiseaseSuccess(response));
      resolve(response);
    } else if (Number(response.code) === -1) {
      throw new Error("Session Expire");
    } else {
      throw new Error(response.message);
    }
  } catch (error) {
    yield put(
      actions.getAssessmentDiseaseError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    // reject(error);
  }
};

const GetAssessmentRequest = function* GetAssessmentRequest({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      API.GetPatientAssessments,
      payload
    );
    if (Number(response.code) === 1) {
      yield put(actions.getAssessmentsSuccess(response));
      resolve(response);
    } else if (Number(response.code) === -1) {
      throw new Error("Session Expire");
    } else {
      throw new Error(response.message);
    }
  } catch (error) {
    yield put(
      actions.getAssessmentsError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    // reject(error);
  }
};

const GetAssessmentAISummaryRequest = function* GetAssessmentAISummaryRequest(
  action: PayloadAction<any>
) {
  try {
    const response: common.ResponseGenerator = yield call(
      API.GetAssessmentAISummary,
      action.payload
    );
    if (Number(response.code) === 1) {
      yield put(actions.getAssessmentAISummarySuccess(response));
    } else {
      const err = response.msg || constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
      yield put(actions.getAssessmentAISummaryError(err));
      toast.error(err);
    }
  } catch (error) {
    const err =
      error instanceof Error
        ? error.message
        : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
    yield put(actions.getAssessmentAISummaryError(err));
    toast.error(err);
  }
};

const GetAIAssessmentsDoneRequest = function* GetAIAssessmentsDoneRequest(
  action: PayloadAction<any>
) {
  try {
    const response: common.ResponseGenerator = yield call(
      API.GetAIAssessmentsDone,
      action.payload
    );
    if (Number(response.code) === 1) {
      yield put(actions.getAIAssessmentsDoneSuccess(response));
    } else {
      const err = response.msg || constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
      yield put(actions.getAIAssessmentsDoneError(err));
      toast.error(err);
    }
  } catch (error) {
    const err =
      error instanceof Error
        ? error.message
        : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
    yield put(actions.getAIAssessmentsDoneError(err));
    toast.error(err);
  }
};

const GetDietPlanDataRequest = function* GetDietPlanDataRequest(
  action: PayloadAction<any>
) {
  try {
    const response: common.ResponseGenerator = yield call(
      API.GetDietPlanData,
      action.payload
    );
    if (Number(response.code) === 1) {
      yield put(actions.getDietPlanDataSuccess(response));
    } else {
      const err = response.msg || constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
      yield put(actions.getDietPlanDataError(err));
      toast.error(err);
    }
  } catch (error) {
    const err =
      error instanceof Error
        ? error.message
        : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG;
    yield put(actions.getDietPlanDataError(err));
    toast.error(err);
  }
};

export default function* dietSaga() {
  yield all([
    takeEvery(actions.getAssessmentDiseaseRequest, GetAssessmentDiseaseRequest),
  ]);
  yield all([takeEvery(actions.getAssessmentsRequest, GetAssessmentRequest)]);
  yield all([
    takeEvery(
      actions.getAssessmentAISummaryRequest,
      GetAssessmentAISummaryRequest
    ),
  ]);
  yield all([
    takeEvery(actions.getAIAssessmentsDoneRequest, GetAIAssessmentsDoneRequest),
  ]);
  yield all([
    takeEvery(actions.getDietPlanDataRequest, GetDietPlanDataRequest),
  ]);
}
